import { Alert } from 'antd';
import { Trans } from 'react-i18next';

export type TimezoneInfoProps = {
  timezone: string;
};

export const TimezoneInfo = ({ timezone }: TimezoneInfoProps) => {
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const isDifferentTimezone = timezone !== userTimezone;

  if (!isDifferentTimezone) return null;

  return (
    <Alert
      type="warning"
      showIcon
      message={
        <Trans
          ns="businessHours"
          i18nKey="timezone"
          values={{ timezone }}
          components={{ tz: <span style={{ fontWeight: 600 }} /> }}
        />
      }
    />
  );
};
